import axios from 'axios';
import { Granule } from '../types/Granule';
import { formatToLocale, stringToUTC } from '../utils/dateUtils';
import { KAPTAIN_URL } from './config';

export const getGranules = async (kapsuleId: string): Promise<Granule[]> => {
  const response = await axios.get<any[]>(`${KAPTAIN_URL}/api/kapsule/${kapsuleId}/read/internal`);
  return response.data.map((item) => {
    return {
      ...item,
      createdAt: formatToLocale(stringToUTC(item.createdAt), item.dateFormat ? item.dateFormat : 'yyyy-MM-dd'),
      updatedAt: formatToLocale(stringToUTC(item.updatedAt), item.dateFormat ? item.dateFormat : 'yyyy-MM-dd'),
    };
  });
};

export const deleteGranules = async (granuleIds: string[]): Promise<void> => {
  await axios.delete(`${KAPTAIN_URL}/api/kapsule/granules`, {
    data: { granuleIds },
  });
};
